import { render } from "./ReferrersList.vue?vue&type=template&id=6128a890&scoped=true"
import script from "./ReferrersList.vue?vue&type=script&lang=js"
export * from "./ReferrersList.vue?vue&type=script&lang=js"

import "./ReferrersList.vue?vue&type=style&index=0&id=6128a890&lang=scss&scoped=true"

import exportComponent from "/src/clientapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6128a890"]])

export default __exports__